import { createPortal } from "react-dom";
import { useHandleLandscapeMode } from "@/hooks/useHandleLandscapeMode";
import { useGameConfiguration } from "@/state/cacheStoreHooks";
import { StrapiMedia } from "@/components/shared/StrapiMedia";
import DefaultContentContainer from "@/components/shared/DefaultContainer/DefaultContentContainer";
import CashCtrlLogo from "@/components/logos/CashCtrlLogo";

export function LandscapeWarningOverlay() {
    const { isLandscape } = useHandleLandscapeMode();
    const gameConfiguration = useGameConfiguration();
    if (!isLandscape) return null;

    return createPortal(
        <div className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-secondary-500">
            {gameConfiguration?.SplashImage && (
                <div className="absolute inset-0 blur-xl">
                    <StrapiMedia
                        size="lg"
                        image={gameConfiguration.SplashImage}
                        className="size-full"
                        objectFit="fill"
                        priority
                        useImageAspectRatio={false}
                    />
                </div>
            )}
            <DefaultContentContainer className="relative p-4  pt-12 flex flex-col" shadow={false} theme="white">
                <div className="absolute -translate-x-1/2 left-1/2" style={{ top: "-108px" }}>
                    <CashCtrlLogo />
                </div>
                <h1 className="font-bold leading-tight w-full text-center text-[32px] text-secondary-500">Ups!</h1>
                <p className="leading-tight text-center mt-3 text-secondary-300">
                    Dieses Game läuft nur im Porträtmodus.
                    <br />
                    Dreh dein Gerät bitte hochkant 😊
                </p>
            </DefaultContentContainer>
        </div>,
        document.body,
    );
}